<header id="header" class="fixed-top navbar navbar-expand-lg navbar-dark bg-white text-end">
  <div class="container-fluid">
    <div class="logo">
      <a data-test-id="main-logo" routerLink="{{ defaultLink }}">
        <img src="/assets/images/logo-1l2c-no-tm.svg" alt="1life2connect" class="logo" />
      </a>
    </div>
    <div class="nav-item notifications-bell ms-auto order-lg-1">
      <div class="notifications-messenger last-message">
        <app-messenger-dropdown
          *ngIf="isAuthenticated && !isAdminSession"
          data-test-id="profile-messages-button"
        ></app-messenger-dropdown>
      </div>
      <app-notifications-dropdown *ngIf="isAuthenticated" (dropdownClosed)="changeNavbarStatus()">
      </app-notifications-dropdown>
    </div>
    <div *ngIf="isAuthenticated" class="profile-box order-lg-2 ml-lg-3 ms-3 me-3">
      <a data-test-id="notification-button" class="notification me-3 d-none" routerLink="{{ defaultLink }}">
        <svg-icon src="assets/icons/icon-bell.svg" class="icon-bell"> </svg-icon>
      </a>
      <div ngbDropdown class="d-inline-block">
        <a ngbDropdownToggle data-test-id="profile-opener">
          <app-small-profile-image
            [profileImage]="avatarLink"
            [accountStatus]="ACTIVE"
            [class]="'user-avatar'"
            [dataTestId]="'user-avatar'"
            [width]="55"
            [height]="55"
          ></app-small-profile-image>
        </a>
        <div ngbDropdownMenu aria-labelledby="dropdownMenuProfile" class="dropdown-menu-right">
          <button
            data-test-id="profile-button"
            [ngClass]="is2AuthLevelPassed ? 'profile-auth' : 'profile-no-auth'"
            ngbDropdownItem
            (click)="secondAuthLevelNav(profileLink)"
          >
            {{ 'PROFILE_NAVIGATION_PROFILE' | translate }}
          </button>
          <ng-container *ngIf="!isAdminSession">
            <button
              routerLink="{{ doctorLinks }}"
              *ngIf="userIsPatient"
              [attr.data-test-id]="'doctor-links-page-button'"
              ngbDropdownItem
            >
              {{ 'PROFILE_NAVIGATION_DOCTORS' | translate }}
            </button>
            <button
              routerLink="{{ patientLinks }}"
              *ngIf="userIsDoctor"
              [attr.data-test-id]="'patient-links-page-button'"
              ngbDropdownItem
            >
              {{ 'PROFILE_NAVIGATION_PATIENTS' | translate }}
            </button>
            <button routerLink="{{ communitiesLink }}" data-test-id="communities-button" ngbDropdownItem>
              {{ 'PROFILE_NAVIGATION_COMMUNITIES' | translate }}
            </button>
            <button routerLink="{{ projectsLink }}" data-test-id="projects-button" ngbDropdownItem>
              {{ 'PROFILE_NAVIGATION_PROJECTS' | translate }}
            </button>
            <button routerLink="{{ postsLink }}" data-test-id="posts-button" ngbDropdownItem>
              {{ 'PROFILE_NAVIGATION_POSTS' | translate }}
            </button>
            <button routerLink="{{ connectionsLink }}" data-test-id="connections-button" ngbDropdownItem>
              {{ 'PROFILE_NAVIGATION_CONNECTIONS' | translate }}
            </button>
            <button
              data-test-id="messages-button"
              [ngClass]="is2AuthLevelPassed ? 'message-auth' : 'message-no-auth'"
              (click)="secondAuthLevelNav(chatLink)"
              ngbDropdownItem
            >
              {{ 'PROFILE_NAVIGATION_MESSAGES' | translate }}
            </button>
            <button
              data-test-id="files-button"
              [ngClass]="is2AuthLevelPassed ? 'files-auth' : 'files-no-auth'"
              ngbDropdownItem
              (click)="secondAuthLevelNav(filesManagerLink)"
            >
              {{ 'PROFILE_NAVIGATION_FILES' | translate }}
            </button>
            <button
              data-test-id="notification-preferences-button"
              [ngClass]="is2AuthLevelPassed ? 'notification-preferences-auth' : 'notification-preferences-no-auth'"
              ngbDropdownItem
              (click)="secondAuthLevelNav(notificationPreferencesLink)"
            >
              {{ 'PROFILE_NAVIGATION_NOTIFICATION_PREFERENCES' | translate }}
            </button>
          </ng-container>

          <ng-container *ngIf="isAdminSession">
            <button
              [ngClass]="is2AuthLevelPassed ? 'profile-auth' : 'profile-no-auth'"
              data-test-id="deactivated-users-button"
              (click)="secondAuthLevelNav(deactivatedUserLink)"
              ngbDropdownItem
            >
              {{ 'PROFILE_NAVIGATION_DEACTIVATED_USERS' | translate }}
            </button>

            <button
              [ngClass]="is2AuthLevelPassed ? 'profile-auth' : 'profile-no-auth'"
              data-test-id="diseases-and-specialties-button"
              (click)="secondAuthLevelNav(charityFocusesLink)"
              ngbDropdownItem
            >
              {{ 'PROFILE_NAVIGATION_CHARITY_FOCUSES' | translate }}
            </button>

            <button
              [ngClass]="is2AuthLevelPassed ? 'profile-auth' : 'profile-no-auth'"
              data-test-id="diseases-and-specialties-button"
              (click)="secondAuthLevelNav(diseasesAndSpecialtiesLink)"
              ngbDropdownItem
            >
              {{ 'PROFILE_NAVIGATION_CATEGORIES' | translate }}
            </button>

            <button
              [ngClass]="is2AuthLevelPassed ? 'profile-auth' : 'profile-no-auth'"
              data-test-id="admins-link"
              (click)="secondAuthLevelNav(adminsLink)"
              ngbDropdownItem
            >
              {{ 'PROFILE_NAVIGATION_ADMINS' | translate }}
            </button>
          </ng-container>
          <button
            operation-managed-control
            (click)="logout()"
            type="button"
            routerLink="{{ defaultLink }}"
            [attr.data-test-id]="LOG_OUT_BUTTON"
            ngbDropdownItem
          >
            {{ 'PROFILE_NAVIGATION_LOG_OUT' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div data-test-id="donate-button-container" class="nav-item order-lg-3 d-none d-lg-block ms-4">
      <app-donate-button data-test-id="donate-button" [isMenuItem]="false"></app-donate-button>
    </div>
    <button
      data-test-id="nav-opener-button"
      (click)="changeNavbarStatus()"
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-target="/navbarHeader"
      aria-controls="navbarHeader"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div [ngbCollapse]="isNavbarCollapsed" class="collapse navbar-collapse" id="navbarHeader">
      <ul class="navbar-nav text-end ms-auto">
        <li class="nav-item">
          <a
            data-test-id="nav-map-button"
            class="nav-link"
            routerLink="map"
            routerLinkActive="active"
            (click)="changeNavbarStatus()"
          >
            {{ 'HEADER_NAVIGATION_MAP' | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a
            data-test-id="nav-search-button"
            class="nav-link"
            routerLink="search"
            routerLinkActive="active"
            (click)="changeNavbarStatus()"
          >
            {{ 'HEADER_NAVIGATION_SEARCH' | translate }}
          </a>
        </li>
        <li *ngIf="!isAuthenticated" class="nav-item">
          <a
            data-test-id="nav-login-button"
            class="nav-link"
            routerLink="{{ loginLink }}"
            routerLinkActive="active"
            (click)="changeNavbarStatus()"
          >
            {{ 'HEADER_NAVIGATION_LOGIN' | translate }}
          </a>
        </li>
        <li *ngIf="!isAuthenticated" class="nav-item">
          <a
            data-test-id="registration-button"
            class="nav-link"
            routerLink="{{ registrationLink }}"
            routerLinkActive="active"
            (click)="changeNavbarStatus()"
          >
            {{ 'HEADER_NAVIGATION_SIGN_UP' | translate }}
          </a>
        </li>
        <li data-test-id="donate-menu-item-container" class="nav-item d-block d-lg-none">
          <app-donate-button
            data-test-id="donate-menu-item"
            class="nav-link"
            [isMenuItem]="true"
            (clickAction)="changeNavbarStatus()"
          ></app-donate-button>
        </li>
      </ul>
    </div>
  </div>
</header>
